export const USE_PRODUCT_REQUEST = 'USE_PRODUCT_REQUEST';
export const USE_PRODUCT_SUCCESS = 'USE_PRODUCT_SUCCESS';
export const USE_PRODUCT_FAILURE = 'USE_PRODUCT_FAILURE';
